module.exports = __webpack_public_path__ + "static/media/Phrygia.616c3948.png";